import { useState } from 'react';
import bgImage from './login background/log_bkg.png';
import './new login form/loginform.css';

type Props = {
  onLogin: (email: string, password: string) => Promise<void>;
  onAnonymousLogin?: () => Promise<void>; // kept for compatibility but hidden from UI
};

export default function Login({ onLogin }: Props) {
  const [email, setEmail] = useState<string>(import.meta.env.VITE_APPWRITE_DEFAULT_EMAIL || '');
  const [password, setPassword] = useState<string>(import.meta.env.VITE_APPWRITE_DEFAULT_PASSWORD || '');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean>(false);

  const handleLoginClick = async () => {
    if (!email || !password) {
      setError('Enter email and password');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await onLogin(email, password);
    } catch (e: any) {
      const message = e?.message || e?.toString?.() || 'Login failed';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen text-white relative overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >

      {/* Background accents */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[580px] h-[580px] rounded-full bg-gradient-to-tr from-rose-700 to-rose-500 blur-[120px] opacity-70" />
      <div className="pointer-events-none absolute bottom-[-200px] left-[-200px] w-[600px] h-[600px] rounded-full bg-gradient-to-tr from-red-900 to-red-700 blur-[140px] opacity-60" />

      {/* Hero */}
      <section className="relative z-10 max-w-6xl mx-auto pt-28 px-6 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-5xl md:text-7xl font-topsecret tracking-tight">Anti Trade Bot</h1>
          <div className="mt-8 space-y-4 text-xs text-gray-400 max-w-lg">
            <div className="flex items-start gap-2">
              <div className="w-3 h-3 border border-gray-500 rounded-sm mt-0.5" />
              <p>Note: This is a trading indicator and should only be used as a guide, not as a standalone decision-making tool.</p>
            </div>
            <p>Remember the markets are not here to play fair, they are here to play risk. Get in , Get out! Trade with a plan.</p>
          </div>

          {/* Inline sign-in form on hero */}
          <div className="mt-12">
            <div className="container">
              <div className="login-box">
                <h2>LOGIN</h2>
                <form onSubmit={(e) => { e.preventDefault(); handleLoginClick(); }}>
                  <div className="input-box">
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <label>Email</label>
                  </div>
                  <div className="input-box">
                    <input
                      type="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <label>Password</label>
                  </div>
                  {/*<div className="forgot-pass">
                    <a href="#">Forgot your password?</a>
                  </div>*/}
                  {error && <div className="forgot-pass" style={{ color: '#fca5a5' }}>{error}</div>}
                  <button className="btn" type="submit" disabled={loading}>
                    {loading ? 'Signing in…' : 'Login'}
                  </button>
                  {/*<div className="signup-link">
                    <a href="#">Sign Up</a>
                  </div>*/}
                </form>
              </div>
              {[...Array(50)].map((_, i) => (
                <span key={i} style={{ ['--i' as any]: i }} />
              ))}
            </div>
          </div>
        </div>

      </section>

      {/* Simple modal sign-in (if user taps nav Sign in) */}
      {showForm && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center" onClick={() => setShowForm(false)}>
          <div className="w-full max-w-sm p-6 bg-gray-900 rounded-lg shadow" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-lg font-semibold mb-4">Sign in</h2>
            <label className="block mb-3">
              <span className="text-sm text-gray-300">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full px-3 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none"
                placeholder="you@example.com"
              />
            </label>
            <label className="block mb-4">
              <span className="text-sm text-gray-300">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full px-3 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none"
                placeholder="••••••••"
              />
            </label>
            {error && <div className="mb-3 text-rose-400 text-sm">{error}</div>}
            <div className="flex gap-3">
              <button
                onClick={handleLoginClick}
                disabled={loading}
                className="px-4 py-2 rounded bg-rose-600 hover:bg-rose-700 disabled:opacity-50"
              >
                {loading ? 'Signing in…' : 'Sign in'}
              </button>
              <button onClick={() => setShowForm(false)} className="px-4 py-2 rounded bg-gray-700 hover:bg-gray-600">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}